import React, { useState } from "react";
import { useAccount, useConnect, useSignMessage } from "wagmi";
import { useAuth } from "../../context/AuthContext";
import {
  formatWalletSessionError,
  WALLET_SIGN_IN_HINT,
  WALLET_SIGN_IN_SUBHINT,
} from "../../lib/ensureTreydoraWalletSession";

/**
 * Connect wallet + signature login (no email/password). Used on dashboard gate and optional auth surfaces.
 */
export default function WalletSignInActions({
  className = "",
  onSuccess,
  redirectToDashboard = false,
}) {
  const { walletLogin, refreshFromStorage } = useAuth();
  const { address, isConnected } = useAccount();
  const { connectAsync, connectors } = useConnect();
  const { signMessageAsync } = useSignMessage();
  const [busy, setBusy] = useState(false);
  const [hint, setHint] = useState("");
  const [err, setErr] = useState("");

  const run = async () => {
    setBusy(true);
    setErr("");
    setHint("");
    try {
      let activeAddress = address;
      if (!isConnected || !activeAddress) {
        const list = Array.isArray(connectors) ? connectors : [];
        const connector = list.find((c) => c?.ready) || list[0];
        if (!connector) {
          throw new Error("No wallet connector available. Install MetaMask or another browser wallet.");
        }
        const connected = await connectAsync({ connector });
        activeAddress = connected?.account;
      }
      if (!activeAddress) {
        throw new Error("Wallet not connected.");
      }
      setHint(WALLET_SIGN_IN_HINT);
      await walletLogin({ walletAddress: activeAddress, signMessageAsync });
      refreshFromStorage();
      setHint("");
      onSuccess?.();
      if (redirectToDashboard && typeof window !== "undefined") {
        window.location.assign("/dashboard");
      }
    } catch (e) {
      setErr(formatWalletSessionError(e));
    } finally {
      setBusy(false);
      setHint("");
    }
  };

  return (
    <div className={`td-wallet-sign-in ${className}`.trim()}>
      <p className="td-wallet-sign-in__lead">{WALLET_SIGN_IN_SUBHINT}</p>
      {hint ? (
        <p className="td-wallet-sign-in__hint" role="status">
          {hint}
        </p>
      ) : null}
      {err ? (
        <p className="td-wallet-sign-in__err" role="alert">
          {err}
        </p>
      ) : null}
      <button type="button" className="dg-btn dg-btn--primary" disabled={busy} onClick={() => run()}>
        {busy ? "Signing…" : "Connect Wallet & Sign In"}
      </button>
    </div>
  );
}
